import { render } from "./ScreenRightSlides.vue?vue&type=template&id=53e011fc&scoped=true&ts=true"
import script from "./ScreenRightSlides.vue?vue&type=script&lang=ts"
export * from "./ScreenRightSlides.vue?vue&type=script&lang=ts"

import "./ScreenRightSlides.vue?vue&type=style&index=0&id=53e011fc&scoped=true&lang=scss"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e011fc"]])

export default __exports__